import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GetPackageConfiService {
  constructor(private http:HttpClient) { }

  getPackageConfig(){
    return this.http.get(environment.apiUrl + "packageConfig/get")
  }
  packageConfigUpdate(data:any){
    return this.http.post(environment.apiUrl + "packageConfig/update", data)
  }

}